export const selfMsgSelector = (state) => state.push.messages;